import { useCallback } from 'react';
import { useLazyGeNotificationsQuery } from 'services';
import { FindAllNotificationDto } from 'types';
import { DEFAULT_PAGE_SIZE, NOTIFICATION_TYPE } from 'utils';
const limit = DEFAULT_PAGE_SIZE;
export function useLazyNotifications() {
  const [trigger, { data: dataResponse, isLoading, isFetching, originalArgs }] = useLazyGeNotificationsQuery();

  const { rows, hasNext, nextCursor } = dataResponse?.data || {};
  const hasMore = hasNext || false;

  const handleLoadMore = useCallback(() => {
    if (hasMore)
      trigger({
        ...originalArgs,
        limit,
        cursor: nextCursor,
        type: [NOTIFICATION_TYPE.INTERNAL_NOTIFICATION, NOTIFICATION_TYPE.TEXT, NOTIFICATION_TYPE.TICKET]
      });
  }, [hasMore, originalArgs, rows]);

  const fetchData = useCallback((value?: Partial<FindAllNotificationDto>) => {
    trigger({
      limit,
      ...originalArgs,
      ...value,
      type: [NOTIFICATION_TYPE.INTERNAL_NOTIFICATION, NOTIFICATION_TYPE.TEXT, NOTIFICATION_TYPE.TICKET]
    });
  }, []);

  return {
    data: rows || [],
    isLoading: isLoading,
    hasMore,
    fetchData,
    handleLoadMore,
    isFetching: isFetching,
    originalArgs
  };
}
